"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var _getOptionValue = _interopRequireDefault(require("./get-option-value"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var buildHourWithAnteMeridiem = function buildHourWithAnteMeridiem(hour, anteMeridiem) {
  var amOrPm = (0, _getOptionValue.default)(_constant.amAndPm, anteMeridiem);
  if (hour) {
    return "".concat(hour, " ").concat(amOrPm, " (ET)");
  }
  return '';
};
var _default = buildHourWithAnteMeridiem;
exports.default = _default;